import { Card, Col, Form, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { EyeOutlined } from "@ant-design/icons";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";
import LoadingSpin from "../../loadingSpin/LoadingSpin";
import DashboardService from "../../../services/DashboardService";
import { useNavigate } from "react-router";

const CardView = ({ userData, onDataAvailable, setGraphData }) => {
    const [cardValue, setCardValue] = useState(null);
    const [lineData, setLineData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isHovered, setIsHovered] = useState(null);
    const [selectedArea, setSelectedArea] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const getLineData = async () => {
            try {
                const response = await DashboardService.getLine();

                if (response && response.line_no) {
                    const Option = response.line_no.map(line => ({
                        label: line,
                        value: line,
                    }));
                    setLineData(Option);
                    if (Option.length > 0) {
                        handleGetData(Option[0].value);
                    }
                } else {
                    ResponseMessage.error({ message: response.message });
                }
            } catch (error) {
                console.error("Error fetching line data:", error);
            }
        };

        getLineData();
    }, []);

    const handleGetData = async (value) => {
        setIsLoading(true);
        try {
            const dashboardData = await DashboardService.getDashboardData(value, userData);
            setCardValue(dashboardData.data);
            setGraphData(dashboardData.data);
            onDataAvailable(true);
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
            onDataAvailable(false);
        } finally {
            setTimeout(() => setIsLoading(false), 1000); // Stop loading spinner after 1 second
        }
    };

    const handleCardClick = (key, value) => {
        setSelectedArea(key); 
        console.log(key);
        console.log("selectedArea", selectedArea);
        
        if (value > 0) {
            navigate(`/eol-dashboard/view?${key}`); 
        } else {
            console.log("No data found");
            ResponseMessage.info("No Data Found")
        }
    };

    return (
        <>
            <Row gutter={54} justify="end" align="top">
                <Col span={8}>
                    {lineData?.length > 0 && (
                        <Form.Item name="selectLine" label="Select Line">
                            <Select
                                getPopupContainer={(trigger) => trigger.parentNode}
                                options={lineData}
                                onChange={handleGetData}
                                defaultValue={lineData[0].value}
                            />
                        </Form.Item>
                    )}
                </Col>
            </Row>
            <div style={{ display: 'flex', justifyContent: 'left' }}>
                {cardValue ? (
                    Object.entries(cardValue).map(([key, value], index) => {
                        const colors = ['#7AECA8', '#E0AF6E', '#5A97D4']; // Green, Brown, Blue
                        const backgroundColor = colors[index % colors.length]; // Cycle through colors

                        return (
                            <Card
                                key={key}
                                style={{
                                    borderRadius: 8,
                                    width: '40%',
                                    height: '140px',
                                    maxWidth: '400px',
                                    margin: '16px',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'flex-start',
                                    backgroundColor,
                                    cursor: "pointer",
                                    transition: "box-shadow 0.3s ease",
                                    position: "relative"

                                }}
                                small
                                onMouseEnter={() => setIsHovered(key)}
                                onMouseLeave={() => setIsHovered(null)}

                                onClick={() => handleCardClick(key, value)}
                            >
                                <h1 style={{
                                    fontSize: 'clamp(16px, 2.5vw, 24px)',
                                    margin: '0 0 8px 0',
                                    lineHeight: 1.2
                                }}>
                                    {value} Pcs
                                </h1>
                                <p style={{
                                    fontSize: 'clamp(12px, 2vw, 18px)',
                                    margin: 0,
                                    lineHeight: 1.2
                                }}>
                                    {key}
                                </p>
                                {isHovered === key && (
                                    <EyeOutlined
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            fontSize: "20px",
                                        }}
                                    />
                                )}
                            </Card>
                        );
                    })
                ) : (
                    <div style={{ marginTop: '10%', marginLeft: '40%' }}>
                        <LoadingSpin />
                    </div>
                )}

                {isLoading && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 10,
                    }}>
                        <LoadingSpin />
                    </div>
                )}
            </div>
        </>
    );
};

export default CardView;
